import React from 'react';
import classNames from 'classnames';

import { NamedLink } from '../../../components';
import { ReactComponent as SmallTickIcon } from './assets/smallTick.svg';
import css from './SectionCategories.module.css';

const SectionCategories = (props) => {
    const {
        config,
        isCarsVariant,
        isRealEstateVariant,
    } = props;
    const categories = config.categoryConfiguration.categories;

    const selectedCategory = isCarsVariant
        ? "cars"
        : isRealEstateVariant
            ? "resi_re"
            : "cars";

    return <div className={classNames(
        css.root,
        {
            [css.rootCars]: isCarsVariant,
            [css.rootRealEstate]: isRealEstateVariant
        },
    )}>
        <div className={css.innerWrapper}>
            <div className={css.subtitle}>
                Select Asset Class
            </div>
            <div className={css.list}>
                {categories.map(c => {
                    const isSelected = c.id == selectedCategory;
                    return <div key={c.id} className={isSelected ? css.carsItem : css.listItem}>
                        {c.name}
                        {isSelected ? <SmallTickIcon /> : null}
                    </div>
                })}
            </div>

            <NamedLink name="NewListingPage" className={css.link}>
                Create listing
            </NamedLink>
        </div>
    </div>
};

export default SectionCategories;
